module.exports = __webpack_public_path__ + "img/shopping-bag.ce3e6cc5.svg";